import React from 'react';
import Classes from '../assets/WHATWEDO-1.png';
import Events from '../assets/WHATWEDO-2.png';
import Resources from '../assets/WHATWEDO-3.png';
import Nonprofit from '../assets/WHATWEDO-4.png';

const items = [
  {
    img: Classes, // replace with actual image paths
    title: 'Academic Classes',
    desc: 'Help for students attending Islamic studies programs, locally or online.',
  },
  {
    img: Events,
    title: 'Events & Conferences',
    desc: 'Funding for seminars, workshops, and conferences, including travel and registration.',
  },
  {
    img: Resources,
    title: 'Academic Resources',
    desc: 'Support for books, study materials, and digital resources.'
  },
  {
    img: Nonprofit,
    title: 'Nonprofit Support',
    desc: 'Assistance for organizations running Islamic educational programs and events'
  }
];

const WhatWeDoSection = () => (
  <section className="whatwedo-section">
    <div className="whatwedo-badge">
      <span role="img" aria-label="book">📚</span> Empower Islamic Learning
    </div>
    <h2 className="whatwedo-title">What We Do</h2>
    <p className="whatwedo-desc">
      We provide grants, resources, and support to make Islamic education accessible and sustainable.
    </p>
    <div className="whatwedo-grid">
      {items.map((item, idx) => (
        <div className="whatwedo-card" key={idx}>
          <img src={item.img} alt={item.title} className="whatwedo-card-img" />
          <div className="whatwedo-card-title">{item.title}</div>
          <div className="whatwedo-card-desc">{item.desc}</div>
        </div>
      ))}
    </div>
  </section>
);

export default WhatWeDoSection;
